// removed by extract-text-webpack-plugin
module.exports = {"content":"styles__content___3rZQR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/styles.css
// module id = 2494
// module chunks = 0